import { useState } from 'react'

type LocalStorage<T> = [T, (newValue: T) => void]

export const useLocalStorageState = <T>(key: string, defaultValue: T): LocalStorage<T> => {
    const [state, setState] = useState<T>(() => {
        const storedValue = localStorage.getItem(key)
        const v: T = storedValue ? JSON.parse(storedValue) : defaultValue
        return v
    })

    const updateState = (newValue: T) => {
        setState(newValue)
        localStorage.setItem(key, JSON.stringify(newValue))
    }

    return [state, updateState]
}
